import React, { useState, useEffect, useContext } from "react";
import { updatePhoneNumber } from "../utils/phoneNumber";
import { FaArrowRightLong } from "react-icons/fa6";
import { UserContext } from "../utils/UserContext";

// Sample images array
const images = [
  "https://content.qeeb.in/coltec/home/phone-number-ebook.webp",
  "https://content.qeeb.in/coltec/home/phone-number-discounts.webp",
  "https://content.qeeb.in/coltec/home/phone-number-newsletter.webp",
  "https://content.qeeb.in/coltec/home/phone-number-free-demo.webp",
  "https://content.qeeb.in/coltec/home/phone-number-latest-trends.webp",
];

// Sample headings and texts arrays
const headings = [
  "Get Your Free Interactive Flat Panel Guide!",
  "Unlock Exclusive Savings!",
  "Join Our Exclusive Insider List!",
  "See It in Action – Book a Free Demo!",
  "Stay Ahead with the Latest Trends!",
];

const texts = [
  "Expert Insights & Smart Buying Tips – Make the best choice for your classroom or office!",
  "Get special discounts on Interactive Flat Panels. Don’t miss out!",
  "Discover new innovations in interactive displays and smart classrooms. Explore Now!",
  "Experience seamless interaction and cutting-edge technology live. Schedule Your Demo Today!",
  "Get latest trends, tips, and deals straight to your inbox. Subscribe Now!",
];

const PhoneNumberModal = ({ onClose }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedHeading, setSelectedHeading] = useState("");
  const [selectedText, setSelectedText] = useState("");
  const [userName, setUserName] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  // Get the current user and setter from context
  const { user, setUser } = useContext(UserContext);

  // Retrieve user data from localStorage and extract first name
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      if (userObj && userObj.name) {
        setUserName(userObj.name.split(" ")[0]);
      }
    }
  }, []);

  // Pick a random index to select matching image, heading, and text when the component mounts
  useEffect(() => {
    const index = Math.floor(Math.random() * images.length);
    setSelectedImage(images[index]);
    setSelectedHeading(headings[index]);
    setSelectedText(texts[index]);
  }, []);

  const handleSubmit = async () => {
    if (!phoneNumber) return;
    try {
      const result = await updatePhoneNumber(phoneNumber);
      if (result.status === 1) {
        // Mark that the phone number has been updated
        localStorage.setItem("phoneNumberUpdated", "true");
        // Also store the updated phone number in its own key
        localStorage.setItem("userPhoneNo", phoneNumber);

        // Update the user object in context and in localStorage with the new phone number
        if (user) {
          const updatedUser = { ...user, phoneNo: phoneNumber };
          setUser(updatedUser);
          localStorage.setItem("user", JSON.stringify(updatedUser));
        }

        setToast({
          show: true,
          message: result.message || "Phone number updated successfully!",
          type: "success",
        });
        // Hide toast after 2 seconds and then close the modal
        setTimeout(() => {
          setToast({ show: false, message: "", type: "" });
          onClose();
        }, 2000);
      } else {
        setToast({
          show: true,
          message: result.message || "Failed to update phone number.",
          type: "error",
        });
        setTimeout(() => {
          setToast({ show: false, message: "", type: "" });
        }, 2000);
      }
    } catch (error) {
      setToast({
        show: true,
        message:
          error.message || "Failed to update phone number. Please try again.",
        type: "error",
      });
      setTimeout(() => {
        setToast({ show: false, message: "", type: "" });
      }, 2000);
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
        <div className="relative animate-zoom-in w-[350px] h-[480px] md:w-[360px] md:h-[491px] mx-4 bg-white rounded-[20px] shadow-[0px_4px_24px_0px_rgba(152,172,198,0.50)] overflow-hidden">
          {/* Close Button */}
          <div className="absolute top-2 right-2 bg-white border border-gray-100 rounded-full w-[30px] h-[30px] flex justify-center items-center">
            <button onClick={onClose}>
              <img
                alt="close-icon"
                className="w-4 text-[#193b68]"
                src="https://content.qeeb.in/coltec/close-icon.svg"
              />
            </button>
          </div>
          <div className="grid grid-cols-1">
            <div>
              <img
                src={selectedImage}
                alt="Promotional"
                className="w-full h-[240px] object-cover"
              />
            </div>
            <div className="p-6 text-center">
              <h3 className="text-[24px] text-username font-bold mb-2">
                Hi, {userName}
              </h3>
              <h2 className="font-semibold max-w-[14rem] mx-auto text-base">{selectedHeading}</h2>
              <p className="text-xs max-w-[17rem] mx-auto text-gray-700 mt-2 mb-4">{selectedText}</p>
              <div className="flex items-center border border-[#9FC9FF] rounded-md overflow-hidden h-[40px]">
                <span className="bg-[#DEECFF] text-gray-700 px-2 py-2.5 text-sm">
                 <img alt="Indian Flag" src="https://content.qeeb.in/coltec/home/indian-flag.svg" className="h-5 w-10"/>
                </span>
                <span className="text-gray-700 text-sm ml-1"> +91</span>
                <input
                  type="text"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Enter your mobile number"
                  className="w-full px-2 py-2 outline-none text-sm focus:shadow-none focus:ring-0 placeholder:text-xs border-0"
                />
                <button
                  onClick={handleSubmit}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-3 rounded-r-md"
                >
                  <FaArrowRightLong />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Toast Message */}
      {toast.show && (
        <div
          className={`fixed top-5 right-5 p-3 rounded shadow-lg text-sm ${
            toast.type === "success"
              ? "bg-green-200 text-green-800"
              : "bg-red-200 text-red-800"
          }`}
        >
          {toast.message}
        </div>
      )}
    </>
  );
};

export default PhoneNumberModal;
